module.exports = __webpack_public_path__ + "img/Collaboration-Global.1e3bb001.svg";